module.exports = __webpack_public_path__ + "static/media/KPO_baner.ff7ee649.jpg";